




































import { Component, Vue } from 'vue-property-decorator';
import '../../assets/css/AccountSetup.scss';
import { validationMixin } from 'vuelidate';
import { ObjectFactory } from '../../config/objectFactory';
import { MedTransGoConstants } from '@/util/constants';
import AddDriverModal from './../modal/AddDriverModal.vue';
import UploadDriverModal from './UploadDriverModal.vue';
import { CommonUtils } from '@/util/commonUtils';
import { ApiRequest, ProfileRequest, QueryRecordsRequest } from '@/types/request';
import { DriverProfile } from '@/types/response';
import DataTable from '@/components/DataTable.vue';
// tslint:disable-next-line: no-var-requires
const DriversTable = require('../../datatable/DriversTable.json');

@Component({
  mixins: [validationMixin],
  components: {
    AddDriverModal,
    UploadDriverModal,
    DataTable,
  },
  props: {
    request: Object,
  },
  validations() {
    const validations = {
      request: {},
    };
    return validations;
  },
})
export default class AddDrivers extends Vue {
  private show = false;
  private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
  private showDriverModal = false;
  private showUploadDriverModal = false;
  private fileName = '';
  private transporterId: any;
  private driverStart = 0;
  private driversDataSource = DriversTable;
  public mounted() {
    this.$props.request.isStepADValid = false;
    if (this.sessionInfo.scopes.includes('transporter')) {
      const profileRequest = this.getProfileRequest();
      profileRequest.isStepADValid = false;
      if (!profileRequest.isStepQnValid) {
        this.$router.push({ name: MedTransGoConstants.VIEW_TRANSPORTATION_QUESTIONNAIRE_NAME });
      }
    } else {
      this.$router.push({ name: MedTransGoConstants.VIEW_TRANSPORTATION_QUESTIONNAIRE_NAME });
    }
    this.transporterId = this.$props.request.transporterId;
    this.getDrivers();
  }

  private async save() {
    this.$router.push({ name: MedTransGoConstants.VIEW_HEALTH_INSURANCE_INFO_NAME });
    this.$props.request.isStepADValid = true;
  }

  private back() {
    this.$router.push({
      name: MedTransGoConstants.VIEW_TRANSPORTATION_QUESTIONNAIRE_NAME,
    });
  }

  private getProfileRequest(): ProfileRequest {
    return this.$props.request as ProfileRequest;
  }

  private async getDrivers(searchString?: string, start?: number) {
    if (typeof start !== 'undefined') {
      this.driverStart = start;
    } else if (this.driverStart > 0) {
      start = this.driverStart;
    }
    if (this.sessionInfo.scopes.includes('transporter') || this.sessionInfo.scopes.includes('dispatcher')) {
      const iHttpService = ObjectFactory.getHttpService();
      const queryRecordsRequest: QueryRecordsRequest = {
        start,
        limit: MedTransGoConstants.PAGINATION_LIMIT,
        order: {
          status: -1,
        },
      };
      const apiRequest: ApiRequest = {
        baseURL: this.$store.state.serverUrl,
        data: queryRecordsRequest,
        url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/list`,
        loaderEvent: {
          show: true,
        },
      };
      const response = await iHttpService.post<DriverProfile[]>(apiRequest);
      if (response.data && response.success) {
        response.data.forEach((element) => {
          if (element.status === 'PENDING_VERIFICATION') {
            element.status = 'Under Review' as any;
          } else if (element.status === 'ACTIVE') {
            element.status = 'Active' as any;
          } else if (element.status === 'DEACTIVATED') {
            element.status = 'Deactive' as any;
          } else if (element.status === 'DEACTIVE') {
            element.status = 'Deactive' as any;
          }
        });
        this.driversDataSource.data = response.data;
        if (response.totalCount !== undefined) {
          this.driversDataSource.totalCount = response.totalCount;
        }
      } else {
        CommonUtils.showError(response);
      }
    }
  }
}
